import GetProfileConfigInfo from "../../domain/entities/getProfileConfigInfo";
import User from "../../domain/entities/getUser";

const hasText = (value?: unknown) => {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === "string") {
    return Boolean(value.trim());
  }

  if (typeof value === "number") {
    return Number.isFinite(value);
  }

  if (typeof value === "boolean") {
    return value;
  }

  return Boolean(String(value).trim());
};

const hasExistingOnboardingProgress = (user?: User) => {
  if (!user) {
    return false;
  }

  return Boolean(
    hasText(user.username) ||
      user.birth ||
      hasText(user.gender_id) ||
      hasText(user.sexual_orientation_id) ||
      hasText(user.marital_status_id) ||
      hasText(user.lat) ||
      hasText(user.lng) ||
      user.profile_pictures?.length
  );
};

const hasCompleteCoreOnboardingProfile = (user?: User) => {
  if (!user) {
    return false;
  }

  return Boolean(
    hasText(user.username) &&
      user.birth &&
      (user.profile_pictures?.length ?? 0) > 0
  );
};

const hasSavedDetails = (user: User, profileConfig?: GetProfileConfigInfo) => {
  const hasCoreDetails =
    hasText(user.gender_id) &&
    hasText(user.sexual_orientation_id) &&
    hasText(user.marital_status_id);

  const hasProfileConfigDetails =
    (profileConfig?.user_has_desire?.length ?? 0) > 0 &&
    (profileConfig?.user_has_showme?.length ?? 0) > 0;

  return hasCoreDetails && hasProfileConfigDetails;
};

const hasSavedLocation = (user: User) =>
  hasText(user.lat) &&
  hasText(user.lng) &&
  hasText(user.country_lat) &&
  hasText(user.country_lng);

export const getFirstIncompleteOnboardingRoute = ({
  user,
  profileConfig,
}: {
  user?: User;
  profileConfig?: GetProfileConfigInfo;
}) => {
  if (!user || !hasExistingOnboardingProgress(user)) {
    return "/";
  }

  if (!hasText(user.username)) {
    return "/username";
  }

  if (!user.birth) {
    return "/birth";
  }

  if (!hasSavedDetails(user, profileConfig)) {
    return "/selectdetails";
  }

  if (!hasSavedLocation(user)) {
    return "/location";
  }

  if ((user.profile_pictures?.length ?? 0) === 0) {
    return "/profilepicture";
  }

  return "/description";
};

export { hasCompleteCoreOnboardingProfile, hasExistingOnboardingProgress };
